<div class="card-container mat-elevation-z1">
    <div class="card-content">
        <div class="card-box-medium margin-right-small">
            <div class="card-header">
                <br />
                <h4>Documentación</h4>
                <mat-divider></mat-divider>
            </div>
            <mat-spinner *ngIf="loading" matSuffix [diameter]="20"></mat-spinner>
            <table mat-table class="documentation-table margin-top-medium" *ngIf="!loading && documentationsDataSource.length > 0" [dataSource]="documentationsDataSource">
                <tr mat-header-row class="table-header" *matHeaderRowDef="displayDocumentationColumns"></tr>
                <tr mat-row class="table-cell" *matRowDef="let row; let i = index; columns: displayDocumentationColumns;"></tr>
                <ng-container matColumnDef="Documentation">
                    <th mat-header-cell class="table-header" *matHeaderCellDef> Documentación </th>
                    <td mat-cell [ngClass]="{'highlight': element.Highlight}" class="table-cell" *matCellDef="let element"> {{element.Documentation}} </td>
                </ng-container>
            </table>
            <div *ngIf="!loading && existsNormative" class="margin-top-small">
                <button *ngIf="!alertNormative" class="margin-left-large" (click)="showNormative()" mat-raised-button>Normas</button>
                <button *ngIf="alertNormative" class="margin-left-large" color="warn" (click)="showNormative()" mat-raised-button>Normas</button>
            </div>
        </div>
        <div class="card-box-medium">
            <div class="card-header">
                <div class="card-inline">
                    <h4>Paciente abona $ {{priceTaxTitle}} {{price.toFixed(2)}}</h4>
                </div>
                <div class="card-inline">
                    <button type="button" class="fab-button-margin" (click)="showPriceDetails()" mat-mini-fab>
            <mat-icon>search</mat-icon>
          </button>
                </div>
                <mat-divider></mat-divider>
            </div>

            <table mat-table *ngIf="showPrice" class="documentation-table margin-top-medium" [dataSource]="pricesDataSource">
                <tr mat-header-row class="table-header" *matHeaderRowDef="displayPricesColumns"></tr>
                <tr mat-row class="table-cell" *matRowDef="let row; let i = index; columns: displayPricesColumns;"></tr>
                <ng-container matColumnDef="Name">
                    <th mat-header-cell class="table-header" *matHeaderCellDef> Práctica </th>
                    <td mat-cell class="table-cell" *matCellDef="let element"> {{element.Name}} </td>
                </ng-container>
                <ng-container matColumnDef="Amount">
                    <th mat-header-cell class="table-header" *matHeaderCellDef> Importe </th>
                    <td mat-cell class="table-cell" *matCellDef="let element"> {{element.Amount.toFixed(2)}} </td>
                </ng-container>
            </table>



            <mat-form-field *ngIf="!ocultarDateOrder">
                <input matInput [value]="dateOrder" (dateChange)="onDateChange($event.target.value)" [matDatepicker]="pickerOrder" placeholder="Fecha de la orden {{validityDays}}">
                <mat-datepicker-toggle matSuffix [for]="pickerOrder"></mat-datepicker-toggle>
                <mat-datepicker #pickerOrder></mat-datepicker>
            </mat-form-field>

            <medical-order-scann-control [medicalsOrderScann]="reservationWizardService.reservation.MedicalOrderScanns" (medicalOrderScannsChange)="onMedicalOrderScannsChange($event)" [hideScanner]="true"></medical-order-scann-control>

        </div>
    </div>
    <div class="clearfix">
        <div class="pull-right margin-right-medium">
            <button class="card-inline" type="button" (click)="reservationWizardService.cancel()" mat-button>CANCELAR</button>
        </div>
        <div class="card-footer">
            <button mat-button color="primary" matStepperPrevious>ANTERIOR</button>
            <button color="primary" mat-flat-button matStepperNext type="submit">SIGUIENTE</button>
        </div>
    </div>
</div>
